export default {"src":"/_next/static/media/our-partners-img-five.6739d746.svg","height":34,"width":150};